
import React from "react";
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Font,
    Image,
} from "@react-pdf/renderer";

import logo from "./../../../img/logo2.png";
import PlusJakartaSansRegular from "./../../../fonts/PlusJakartaSans-Regular.ttf";

import { rupeesToWords } from "../../../helpers/functions/rupeesToWords";



import PlusJakartaSansBold from "./../../../fonts/PlusJakartaSans-Bold.ttf";
import { DateConverterForInputField, formatDateDDMMYYYY, formatDateWithSuffix } from "../../../helpers/functions/dateFormatter";


Font.registerHyphenationCallback(word => [word]);

Font.register({
    family: "Plus Jakarta Sans",
    fonts: [
        { src: PlusJakartaSansRegular, fontWeight: "normal" },
        { src: PlusJakartaSansBold, fontWeight: "bold" },
    ],
});


const styles = StyleSheet.create({
    page: {
        fontSize: 8,
        padding: 30,
        fontFamily: "Plus Jakarta Sans",
        fontWeight: "light",
        lineHeight: 1.5,
    },
    heading: {
        fontSize: 12,
        textAlign: "center",
        marginBottom: 20,
        fontFamily: "Plus Jakarta Sans",
        fontWeight: "bold"
    },
    section: {
        marginBottom: 10,
    },
    boldText: {
        fontFamily: "Plus Jakarta Sans",
        fontWeight: "bold",
        fontSize: 10,
        marginBottom: 2,
    },
    normalText: {
        fontFamily: "Courier",
        fontSize: 8,
    },
    logo: {
        width: 120,
        marginBottom: 5,
    },
    headerRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: 20,
    },
    leftColumn: {
        flex: 1,
    },
    rightColumn: {
        flex: 0.2,
        alignItems: "center",
        borderWidth: 1,
        borderColor: "#ccc",
        padding: 2,
        borderRadius: 4,
    },
    qrImage: {
        width: 70,
        height: 70,
        marginBottom: 5,
    },
    qrText: {
        fontSize: 6,
        textAlign: "center",
        fontFamily: "Plus Jakarta Sans",

    },
    invoiceDetails: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginVertical: 10,
        borderTopWidth: 1,
        borderBottomWidth: 1,
        borderColor: "#ccc",
        paddingTop: 10,
        paddingBottom: 10,


    },
    billToSection: {
        flex: 1,
    },
    invoiceInfoSection: {
        flex: 0.3,
        marginLeft: 10,
        alignItems: "start",
    },
    table: {
        display: "table",
        width: "100%",
        borderBottomWidth: 1,
        borderColor: "#ccc",

    },
    tableHeaderRow: {
        flexDirection: "row",
        paddingVertical: 6,
        borderBottomWidth: 1,
        borderColor: "#ccc",
        fontWeight: "bold",
    },
    tableRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderColor: "#eee",
        paddingVertical: 6,
    },
    tableColDescription: {
        flex: 3,
        fontSize: 9,
        paddingHorizontal: 4,
        width: "25%"
    },
    tableColSmall: {
        flex: 1,
        fontSize: 9,
        textAlign: "center", width: "14%"
    },
    tableColMedium: {
        flex: 1.5,
        fontSize: 9,
        textAlign: "right",
        paddingRight: 4,
        width: "14%"
    },
    colAmount: {
        flex: 1.5,
        fontSize: 9,
        textAlign: "right",
        paddingRight: 4,
    },
    tableColTax: {
        flex: 1.5,
        fontSize: 9,
        textAlign: "right",
        paddingRight: 4,
    },
    colTotal: {
        flex: 1.5,
        fontSize: 9,
        textAlign: "right",
        paddingRight: 4,
    },
    summaryRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        paddingVertical: 6,
        borderColor: "#ccc",
    },
    summaryLabelTotal: {
        fontSize: 10,
        fontWeight: "bold",
    },
    summaryValueTotal: {
        fontSize: 10,
        fontWeight: "bold",
        textAlign: "right",
    },
    footer: {
        position: "absolute",
        bottom: 30,
        left: 40,
        right: 40,
        fontSize: 8,
        textAlign: "center",
    },
});



const TaxInvoice = ({ formData, data, gstIncluded, subtotalAmount, qrCodeBase64, totalAmount ,type}) => {

    const invoiceDate = new Date(formData.invoiceDate);
     const dueDate = new Date(formData.dueDate);
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <Text style={styles.heading}>Tax Invoice</Text>

                <View style={styles.headerRow}>
                    {/* Left: Logo + Company Info */}
                    <View style={styles.leftColumn}>
                        <Image src={logo} style={styles.logo} />
                        <Text style={styles.boldText}>Krishak Sevita Online Solution Pvt Ltd</Text>
                        <Text>{`Flat No 303, Building B, Kumar Gulmohar,
                                Near Nancy Gardens, Wanawadi, 
                                Pune- 411040, Maharashtra, IN`}</Text>
                        <Text>GST: 27AAFCK9361C1ZH</Text>
                        <Text>Email: contact@meratractor.com</Text>
                        <Text>Phone: +91 8888009900</Text>
                    </View>

                    {/* Right: QR code */}
                    <View style={styles.rightColumn}>
                        <Image src={qrCodeBase64} style={styles.qrImage} />
                        <Text style={styles.qrText}>Scan for Details</Text>
                        <Text style={styles.qrText}>Invoice #{formData.invoiceNumber || "INV-XXXXXX"}</Text>
                    </View>
                </View>

                {/* Billing & Invoice Info */}
                <View style={styles.invoiceDetails}>
                    <View style={styles.billToSection}>
                        <Text style={styles.boldText}>Bill To:</Text>
                        <Text>{data.name || "NA"}</Text>
                        {
                            data?.address!=="-" &&    <Text>{data?.address || "NA"}</Text>
                        }
                     
                        <Text>Email: {data.email || "N/A"}</Text>
                        <Text>Phone: {data.phone || "N/A"}</Text>
                        <Text>State: {data.state || "N/A"}</Text>
                    </View>

                    <View style={styles.invoiceInfoSection}>
                        <Text>Invoice #: {formData.invoiceNumber || "INV-XXXXXX"}</Text>
                        {
                            type === "bharat_loan" ?  <Text>Date: {formatDateWithSuffix(invoiceDate) || "DD/MM/YYYY"}</Text>   : <Text>Date: {formatDateDDMMYYYY(invoiceDate) || "DD/MM/YYYY"}</Text>
                        }
                      
                        {
                            formData?.dueDate !=="" && formData?.dueDate?.length > 4 &&
                             <Text>Due Date: {formatDateDDMMYYYY(dueDate) || "DD/MM/YYYY"}</Text>
                        }
                       
                    </View>
                </View>





                <View style={styles.table}>
                    {/* Table Header */}
                    <View style={styles.tableHeaderRow}>
                        <Text style={styles.tableColDescription}>Description</Text>
                        <Text style={styles.tableColSmall}>Qty</Text>
                        {
                            type !== "bharat_loan" &&  <Text style={styles.tableColMedium}>Rate</Text>
                        }
                       
                        <Text style={styles.tableColMedium}>Amount</Text>
                        {data.state === "Maharashtra" ? (
                            <>
                                <Text style={styles.tableColTax}>CGST (9%)</Text>
                                <Text style={styles.tableColTax}>SGST (9%)</Text>
                            </>
                        ) : (
                            <Text style={styles.tableColTax}>IGST (18%)</Text>
                        )}
                        <Text style={styles.tableColMedium}>Subtotal</Text>
                    </View>

                    {/* Table Rows */}
                    {formData.items.map((item, index) => {
                        const itemunit_price = !gstIncluded
                            ? Number( item?.unit_price).toFixed(2)
                            : ( item?.unit_price / 1.18).toFixed(2);
                        const itemAmount = !gstIncluded
                            ? Number(item.amount).toFixed(2)
                            : (item.amount / 1.18).toFixed(2);

                        const cgst = (itemAmount * 0.09).toFixed(2);
                        const sgst = (itemAmount * 0.09).toFixed(2);
                        const igst = (itemAmount * 0.18).toFixed(2);
                        const total = data.state === "Maharashtra"
                            ? (Number(itemAmount) + Number(cgst) + Number(sgst)).toFixed(2)
                            : (Number(itemAmount) + Number(igst)).toFixed(2);

                        return (
                            <View key={index} style={styles.tableRow}>
                                <Text style={styles.tableColDescription}>{item.description}</Text>
                                <Text style={styles.tableColSmall}>{item.quantity}</Text>
                                   {
                            type !== "bharat_loan" &&     <Text style={styles.tableColMedium}>{itemunit_price}</Text>
                        }
                             
                                <Text style={styles.tableColMedium}>{itemAmount}</Text>
                                {data.state === "Maharashtra" ? (
                                    <>
                                        <Text style={styles.tableColTax}>{cgst}</Text>
                                        <Text style={styles.tableColTax}>{sgst}</Text>
                                    </>
                                ) : (
                                    <Text style={styles.tableColTax}>{igst}</Text>
                                )}
                                <Text style={styles.tableColMedium}>{total}</Text>
                            </View>
                        );
                    })}



                    <View style={styles.summaryRow}>
                        <Text style={styles.summaryLabelTotal}>Total Amount:</Text>
                        <Text style={styles.summaryValueTotal}>
                            Rs. {Number(subtotalAmount).toFixed(2)}
                        </Text>
                    </View>
                    <View style={styles.summaryRow}>
                        <Text style={styles.summaryLabelTotal}></Text>
                        <Text style={styles.summaryValueTotal}>
                            {rupeesToWords(Number(subtotalAmount).toFixed(2))}
                        </Text>

                    </View>

                </View>


                {/* Footer */}
                <View style={styles.footer}>
                    <Text>Thank you for your business!</Text>
                    <Text>This is a computer generated invoice and does not require a signature.</Text>
                </View>
            </Page>
        </Document>
    );
};

export default TaxInvoice;

